import { ReactComponent as Teams } from '../assets/svgIcons/lsq_teams_disabled.svg';
import { ReactComponent as TeamsActive } from '../assets/svgIcons/lsq_teams_active.svg';
import { ReactComponent as LsqUnassign } from '../assets/svgIcons/lsq_unassign.svg';
import { ReactComponent as LsqUnpublish } from '../assets/svgIcons/lsq_unpublish.svg';
import { ReactComponent as LsqClone } from '../assets/svgIcons/lsq_clone.svg';
import { ReactComponent as LsqDelete } from '../assets/svgIcons/delete_filled.svg';
import { ReactComponent as LsqPublish } from '../assets/svgIcons/lsq_ok.svg';
import { ReactComponent as Help } from '../assets/svgIcons/lsq_help.svg';
import { ReactComponent as HelpFilled } from '../assets/svgIcons/lsq_help_filled.svg';
import { ReactComponent as Homepages } from '../assets/svgIcons/homepages.svg';
import { ReactComponent as HomepagesFilled } from '../assets/svgIcons/homepages_filled.svg';
import { ReactComponent as LaunchBar } from '../assets/svgIcons/launch_bar.svg';
import { ReactComponent as LaunchBarFilled } from '../assets/svgIcons/launch_bar_filled.svg';
import { ReactComponent as Navbar } from '../assets/svgIcons/navbar.svg';
import { ReactComponent as NavbarFilled } from '../assets/svgIcons/navbar_filled.svg';
import { ReactComponent as MenuBuilder } from '../assets/svgIcons/lsq_menu.svg';
import { ReactComponent as MenuBuilderFilled } from '../assets/svgIcons/lsq_menu_filled.svg';
import { ReactComponent as ThemeFilled } from '../assets/svgIcons/lsq_themes_filled.svg';
import { ReactComponent as Theme } from '../assets/svgIcons/lsq_themes.svg';
import { ReactComponent as LeadControl } from '../assets/svgIcons/lead_control.svg';
import { ReactComponent as LeadControlFilled } from '../assets/svgIcons/lead_control_filled.svg';
import { ReactComponent as Object360 } from '../assets/svgIcons/object360.svg';
import { ReactComponent as Object360Filled } from '../assets/svgIcons/object360_filled.svg';
import { ReactComponent as Announcements } from '../assets/svgIcons/announcements.svg';
import { ReactComponent as AnnouncementsFilled } from '../assets/svgIcons/announcements_filled.svg';
import {
  ROUTES_PATH,
  casaConstants,
  homepageConstants,
  menuBuilderConstants
} from '../constants/globalConstant';
import { teamsDashboardsMappingWithTeamId } from './reducersUtils';
import { ReactComponent as WebHomepageFilled } from '../assets/svgIcons/web_homepage_filled.svg';
import { ReactComponent as WebHomepage } from '../assets/svgIcons/web_homepage.svg';

export const sideMenuOptions = (defaultPath, dynamicLabels) => {
  return [
    {
      groupName: homepageConstants.TEAMS,
      displayName: homepageConstants.TEAM_MANAGEMENT,
      options: [
        {
          path: defaultPath,
          displayIcon: <Teams />,
          activeIcon: <TeamsActive />,
          tooltip: homepageConstants.TEAM_ASSIGNMENT,
          view: homepageConstants.TEAM_ASSIGNMENT_VIEW,
          type: homepageConstants.INTERNAL,
          associatedPaths: [ROUTES_PATH.home, ROUTES_PATH.webTeams],
          analyticsMessage: 'teams_view_click',
          'data-testid': 'team-assignment-view-tab',
          addShortCut: false
        }
      ],
      showGroupName: true
    },
    {
      groupName: homepageConstants.MOBILE,
      displayName: homepageConstants.MOBILE,
      options: [
        {
          path: ROUTES_PATH.homepages,
          displayIcon: <Homepages />,
          activeIcon: <HomepagesFilled />,
          tooltip: homepageConstants.HOMEPAGES,
          view: homepageConstants.HOMEPAGES_VIEW,
          type: homepageConstants.INTERNAL,
          associatedPaths: [ROUTES_PATH.homebuilder, ROUTES_PATH.templates],
          analyticsMessage: 'hompeages_view_click',
          'data-testid': 'home-view-tab',
          addShortCut: true
        },
        {
          path: ROUTES_PATH.menus,
          displayIcon: <MenuBuilder />,
          activeIcon: <MenuBuilderFilled />,
          tooltip: homepageConstants.MENUS,
          view: homepageConstants.MENU_BUILDER_VIEW,
          type: homepageConstants.INTERNAL,
          associatedPaths: [ROUTES_PATH.menubuilder],
          analyticsMessage: 'menu_view_click',
          'data-testid': 'menu-builder-view-tab',
          addShortCut: true
        },
        {
          path: ROUTES_PATH.themebuilder,
          displayIcon: <Theme />,
          activeIcon: <ThemeFilled />,
          tooltip: homepageConstants.THEMING,
          view: homepageConstants.THEME_BUILDER_VIEW,
          type: homepageConstants.INTERNAL,
          analyticsMessage: 'theme_view_click',
          'data-testid': 'theme-view-tab',
          addShortCut: false
        },
        {
          path: ROUTES_PATH.leadControls,
          displayIcon: <LeadControl />,
          activeIcon: <LeadControlFilled />,
          tooltip: dynamicLabels[ROUTES_PATH.leadControls],
          view: homepageConstants.LEAD_CONTROLS_VIEW,
          type: homepageConstants.INTERNAL,
          analyticsMessage: 'lead_control_view_click',
          'data-testid': 'lead_control_view-tab',
          addShortCut: false
        },
        {
          path: ROUTES_PATH.announcements,
          displayIcon: <Announcements />,
          activeIcon: <AnnouncementsFilled />,
          tooltip: homepageConstants.ANNOUNCEMENTS,
          view: homepageConstants.ANNOUNCEMENTS_VIEW,
          type: homepageConstants.INTERNAL,
          analyticsMessage: 'announcements_view_click',
          'data-testid': 'announcements_view-tab',
          addShortCut: false
        }
      ],
      showGroupName: true
    },
    {
      groupName: homepageConstants.WEB,
      displayName: homepageConstants.WEB,
      id: 'casa_web_side_nav',
      options: [
        {
          path: ROUTES_PATH.webDashboards,
          displayIcon: <WebHomepage />,
          activeIcon: <WebHomepageFilled />,
          tooltip: homepageConstants.WEB_DASHBOARD,
          view: homepageConstants.WEB_DASHBOARD_VIEW,
          type: homepageConstants.INTERNAL,
          analyticsMessage: 'web_dashboard_page_view_click',
          'data-testid': 'web_dashboard_view-tab',
          addShortCut: true
        },
        // {
        //   path: ROUTES_PATH.webHomepage,
        //   displayIcon: <WebHomepage />,
        //   activeIcon: <WebHomepageFilled />,
        //   tooltip: homepageConstants.WEB_HOMEPAGE,
        //   view: homepageConstants.WEB_HOMEPAGE_VIEW,
        //   type: homepageConstants.INTERNAL,
        //   analyticsMessage: "web_homepage_view_click",
        //   "data-testid": "web_homepage_view-tab",
        //   addShortCut: false,
        // },
        {
          path: ROUTES_PATH.launchBar,
          displayIcon: <LaunchBar />,
          activeIcon: <LaunchBarFilled />,
          tooltip: homepageConstants.WEB_LAUNCHBAR,
          view: homepageConstants.WEB_LAUNCHBAR_VIEW,
          type: homepageConstants.INTERNAL,
          analyticsMessage: 'web_launchbar_view_click',
          'data-testid': 'web_launchbar_view-tab',
          addShortCut: true
        },
        {
          path: ROUTES_PATH.topNavigation,
          displayIcon: <Navbar />,
          activeIcon: <NavbarFilled />,
          tooltip: homepageConstants.WEB_TOP_NAVIGATION,
          view: homepageConstants.WEB_TOP_NAVIGATION_VIEW,
          type: homepageConstants.INTERNAL,
          analyticsMessage: 'web_navbar_view_click',
          'data-testid': 'web_navbar_view-tab',
          addShortCut: false
        },
        {
          path: ROUTES_PATH.object360,
          displayIcon: <Object360 />,
          activeIcon: <Object360Filled />,
          tooltip: dynamicLabels[ROUTES_PATH.object360],
          view: homepageConstants.OBJECT_360_VIEW,
          type: homepageConstants.INTERNAL,
          analyticsMessage: 'object_360_view_click',
          'data-testid': 'object_360_view-tab',
          addShortCut: false
        }
      ],
      showGroupName: true
    }
  ];
};

export const menuConfiguratorTabs = [
  {
    key: menuBuilderConstants.BOTTOM_NAVIGATION,
    value: menuBuilderConstants.BOTTOM_NAVIGATION,
    id: 'bottom-navigation',
    'data-testid': 'bottom-navigation'
  },
  {
    key: menuBuilderConstants.SIDE_NAVIGATION,
    value: menuBuilderConstants.SIDE_NAVIGATION,
    id: 'side-navigation',
    'data-testid': 'side-navigation'
  }
];

export const sideMenuBottomOptions = [
  {
    displayIcon: <Help />,
    activeIcon: <HelpFilled />,
    view: homepageConstants.HELP_DESK_VIEW,
    tooltip: homepageConstants.HELP_DESK,
    onClick: () => {
      window.open('https://help.leadsquared.com/mobile-home-builder/', '_blank');
    },
    type: homepageConstants.EXTERNAL,
    'data-testid': 'help-desk',
    addShortCut: false
  }
];

export const isLastHomepage = (selectedHomepageId, homepageId) => {
  const routedHomepageId = +homepageId;
  return selectedHomepageId == routedHomepageId;
};

export const teamsViewActions = (status) => {
  return [
    {
      displayIcon:
        status === casaConstants.PUBLISHED ? (
          <LsqUnpublish />
        ) : (
          <LsqPublish style={{ fill: 'rgb(var(--ng-neutral-20))', transform: 'scale(1.3)' }} />
        ),
      name: status === casaConstants.PUBLISHED ? casaConstants.UNPUBLISH : casaConstants.PUBLISH,
      backgrounColor: 'rgb(var(--ng-primary-50))',
      'data-testid': 'unPublish-action'
    },
    {
      displayIcon: <LsqUnassign />,
      name: casaConstants.UNASSIGN,
      backgrounColor: 'rgb(var(--ng-red-50))',
      'data-testid': 'unAssign-action'
    }
  ];
};
export const dashboardViewActions = (selectedHomepageId, homepageId) => {
  const result = isLastHomepage(selectedHomepageId, homepageId);
  let menuItems = [
    {
      displayIcon: <LsqClone />,
      name: casaConstants.CLONE,
      backgrounColor: 'rgb(var(--ng-primary-50))',
      'data-testid': 'clone-action'
    }
  ];
  if (result === false)
    menuItems.push({
      displayIcon: <LsqDelete />,
      name: casaConstants.DELETE,
      backgrounColor: 'rgb(var(--ng-red-50))',
      'data-testid': 'unAssign-action'
    });

  return menuItems;
};

export const getUpdatedTeamDashboards = (data, teamDashboards) => {
  const _teamDashboards = { ...teamDashboards };
  const updatedTeamHomepagesByTeamId = teamsDashboardsMappingWithTeamId(
    teamDashboards.teamsDashboards,
    data.teamDashboards
  );
  _teamDashboards.teamsDashboards = Object.values(updatedTeamHomepagesByTeamId);
  if (data.defaultDashboards) {
    _teamDashboards.defaultDashboards = data.defaultDashboards;
  }
  return _teamDashboards;
};

export const getRecentlyModifiedDashboard = (dashboards) => {
  if (dashboards.length != 0) {
    return dashboards.reduce(function (prev, current) {
      return new Date(current.updatedAt) > new Date(prev.updatedAt) ? current : prev;
    });
  }
};
export const searchWidgets = (widgetList, searchText) => {
  if (searchText.trim() === '') return widgetList;
  return widgetList?.filter(({ title }) =>
    title.toLowerCase().includes(searchText.trim().toLowerCase())
  );
};

export const homepageFilterItems = [
  {
    value: casaConstants.ALL,
    key: casaConstants.ALL,
    id: 'homepages-all',
    'data-testid': 'all-homepages'
  },
  {
    value: casaConstants.PUBLISHED,
    key: casaConstants.PUBLISHED,
    id: 'homepages-published',
    'data-testid': 'published-homepages'
  },
  {
    value: casaConstants.UNPUBLISHED,
    key: casaConstants.UNPUBLISHED,
    id: 'homepages-unpublished',
    'data-testid': 'unpublished-homepages'
  },
  {
    value: casaConstants.DRAFT,
    key: casaConstants.DRAFT,
    id: 'homepages-draft',
    'data-testid': 'draft-homepages'
  },
  {
    value: casaConstants.FAVOURITE,
    key: casaConstants.FAVOURITE,
    label: 'Favourites',
    id: 'homepages-favourite',
    'data-testid': 'favourite-homepages'
  }
];
